import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { Text } from '_/components';
import themes from '_/constants/themes';
import { fontFamily } from '_/config/theme';
import { useTranslation } from 'react-i18next';

type Props = {
  filter: 'all' | 'approved' | 'pending' | 'denied' | null;
};

export function EmptyActivities({ filter }: Props) {
  const { t: translate } = useTranslation();

  const getMessage = () => {
    switch (filter) {
      case 'approved':
        return translate('visits.empty.approvedTitle');
      case 'pending':
        return translate('visits.empty.pendingTitle');
      case 'denied':
        return translate('visits.empty.deniedTitle');
      default:
        return translate('visits.empty.allTitle');
    }
  };

  const getSubMessage = () => {
    switch (filter) {
      case 'approved':
        return translate('visits.empty.approvedDesc');
      case 'pending':
        return translate('visits.empty.pendingDesc');
      case 'denied':
        return translate('visits.empty.deniedDesc');
      default:
        return translate('visits.empty.allDesc');
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <Feather name="calendar" size={48} color={themes.colors.graySecondary} />
      </View>

      <Text style={styles.title}>{getMessage()}</Text>
      <Text style={styles.subtitle}>{getSubMessage()}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
    paddingBottom: 60,
  },
  iconContainer: {
    height: 80,
    width: 80,
    borderRadius: 40,
    backgroundColor: themes.colors.lightPrimary,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
  },
  title: {
    fontSize: 16.5,
    fontFamily: fontFamily.semibold,
    color: themes.colors.grayPrimary,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 14,
    marginTop: 6,
    color: themes.colors.graySecondary,
    textAlign: 'center',
    lineHeight: 18,
  },
});
